module.exports = __webpack_public_path__ + "img/weserve-logo.6ff0b191.png";